<template>
    <v-dialog
        v-model="dialog"
        max-width="720"
    >
        <v-card
            v-if="progress.bulk_message_state == 'send'"
        >
            <v-card-title class="headline">
                Sending Bulk Message
            </v-card-title>

            <v-card-text>
                <p>
                    {{progress.count_total - progress.count_pending}} messages sent of {{progress.count_total}} messages total ({{percent_total}}%).
                    <br>
                    Time elapsed: {{time_elapsed}}, estimated total time: {{time_total}}.
                </p>
                <p>
                    Messages will continue to send in the background, you do not need to remain on this screen.<br/>
                    Feel free to go monitor the replies to this message by clicking <a v-on:click="generateEndpointLink">here.</a><br/>
                    You can continue to monitor the send process <a @click="onViewSendSummary">here.</a>
                </p>
            </v-card-text>

            <v-card-actions>

                 <v-btn
                    text
                    @click="onClickHome"
                >
                    Home
                </v-btn>

                <v-spacer></v-spacer>

                <v-btn
                    color="primary darken-1"
                    text
                    @click="onClickPause"
                >
                    Pause
                </v-btn>

            </v-card-actions>
        </v-card>

        <v-card
            v-if="progress.bulk_message_state == 'paused'"
        >
            <v-card-title class="headline">
                Sending is currently paused
            </v-card-title>

            <v-card-text>

                <p>No further messages will be sent until you click "resume sending"</p>

                <p><b>Progress so far</b></p>

                <p>
                    {{progress.count_total - progress.count_pending}} of {{progress.count_total}} messages ({{percent_total}}%) had been sent before pausing.
                </p>

                <p><b>Need to make a change?</b></p>

                <p>
                    Cancel this bulk message and create a new one. Tip: you can export this recipient list, delete the recipients that received this message, and upload the remaining recipients to your new bulk message.
                </p>

                <p><b>Don't want to send any more?</b></p>

                <p>
                    Type "Cancel" below to make the "Cancel Bulk Message" option appear and then select it. No one will be able to resume this bulk message again. <b>This cannot be undone.</b>
                </p>

                <v-text-field
                    label="Cancel Bulk Message"
                    hint="Type cancel"
                    persistent-hint
                    v-model="cancel_text"
                />

            </v-card-text>

            <v-card-actions>

                <v-btn
                    text
                    @click="onClickHome"
                >
                    Home
                </v-btn>

                <v-spacer></v-spacer>

                <v-btn
                    color="primary darken-1"
                    text
                    @click="onClickResume"
                    v-if="cancel_text == null || cancel_text.trim().toLowerCase() != 'cancel'"
                >
                    Resume Sending
                </v-btn>
                <v-btn
                    color="primary darken-1"
                    text
                    @click="onClickCancel"
                    v-else
                >
                    Cancel Bulk Message
                </v-btn>

            </v-card-actions>
        </v-card>

        <v-card
            v-if="progress.bulk_message_state == 'finished'"
        >
            <v-card-title class="headline">
                Finished Sending Bulk Message
            </v-card-title>

            <v-card-text>
                <p>
                    Sending complete
                </p>
            </v-card-text>

            <v-card-actions>

                <v-spacer></v-spacer>

                <v-btn
                    color="primary darken-1"
                    text
                    @click="onOk"
                >
                    Close
                </v-btn>

            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
const _ = require('lodash');
const E164 = require('@/js/E164.js');
const { v4: uuidv4 } = require('uuid');


export default {
    data() {
        return {
            dialog: false,
            from_endpoint: null,
            current_time: new Date().getTime(),

            progress: {
                'organization_id': '00000000-00000000-00000000-00000000',
                'bulk_message_id': '00000000-00000000-00000000-00000000',
                'bulk_message_state': 'edit',
                'label': 'Message label',
                'count_total': 10,
                'count_pending': 10,
                'count_sent': 0,
                'count_failed': 0,
            },

            interval: null,
            cancel_text: null,
        }
    },

    mounted () {
        this.interval = window.setInterval(this.updateTime, 1000);
    },

    beforeDestroy () 
    {
        if ( this.interval != null )
        {
            window.clearInterval(this.interval);
            this.interval = null;
        }
    },

    methods: {

        updateTime()
        {
            this.current_time = new Date().getTime();
        },

        updateProgress(progress, from_endpoint)
        {
            let just_finished = this.progress.bulk_message_state == 'send' && progress.bulk_message_state == 'finished';

            this.progress = _.cloneDeep(progress);
            this.current_time = new Date().getTime();
            this.from_endpoint = from_endpoint;

            if ( progress.bulk_message_state == 'send' || progress.bulk_message_state == 'paused' )
            {
                if ( this.dialog == false ) 
                    this.cancel_text = null;

                this.dialog = true;
            }
        },

        onOk()
        {
            this.$emit('completed');
            this.dialog = false;
        },

        generateEndpointLink()
        {
            let url = this.$router.resolve({
                'name' : 'home-routed',
                'params' : {
                    'endpoint' : E164.slimEndpoint(this.from_endpoint),
                    'conversation_id' : 'none',
                }
            });

            window.open(url.href, '_blank');
        },

        onViewSendSummary()
        {
            let url = this.$router.resolve({
                'name': 'view-bulk-message-send-summary',
                'params' : {
                    'organization_id' : this.$route.params.organization_id,
                    'bulk_message_id' : this.progress.bulk_message_id,
                }
            });

            window.open(url.href, '_blank');
        },

        onClickPause()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/bulk/pause',
            
                'params' : {
                        'bulk_message_id': this.progress.bulk_message_id,
                        'user_action_id': uuidv4()
                    },
            
                'on_success': (data) => {
                        this.progress.bulk_message_state = 'paused';
                    },
            
                'on_error': 'Unable to pause bulk message',
            });
        },

        onClickResume()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/bulk/resume',
            
                'params' : {
                        'bulk_message_id': this.progress.bulk_message_id,
                        'user_action_id': uuidv4()
                    },
            
                'on_success': (data) => {
                        this.progress.bulk_message_state = 'send'; // to immediately change the dialog
                    },
            
                'on_error': 'Unable to resume bulk message',
            });
        },

        onClickCancel()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/bulk/cancel',
            
                'params' : {
                        'bulk_message_id': this.progress.bulk_message_id,
                    },
            
                'on_success': (data) => {
                        this.progress.bulk_message_state = 'cancelled'; // to immediately change the dialog
                        this.$rc.snackbar('Sending this bulk message has been cancelled');
                        this.dialog = false;

                        window.setTimeout(
                            () => {
                                this.$emit('completed');
                            },
                            1000
                        );

                        window.setTimeout(
                            () => {
                                this.$emit('completed');
                            },
                            5000
                        );

                        window.setTimeout(
                            () => {
                                this.$emit('completed');
                            },
                            10000
                        );
                    },
            
                'on_error': 'Unable to cancel bulk message',
            });
        },

        onClickHome()
        {
            this.$router.push({
                'name': 'home',
                'params' : {
                    'organization_id' : this.$rc.$state.organization_id,
                }
            }).catch(e=>{}); // swallow any exception
        },
    },

    computed: {

        time_elapsed() {
            let time_start = this.progress.time_start_send == null ? this.current_time : this.progress.time_start_send;

            let delta = this.current_time - time_start;

            let minutes = Math.floor((delta % (1000 * 60 * 60)) / (1000 * 60));
            let seconds = Math.floor((delta % (1000 * 60)) / 1000);

            if ( seconds < 10 )
            {
                seconds = '0' + seconds;
            }

            if ( minutes < 10 )
            {
                minutes = '0' + minutes;
            }

            return minutes + ":" + seconds;
        },

        time_total() {
            let total_seconds = (this.progress.count_total) * 2;

            let seconds = total_seconds % 60;
            let minutes = Math.floor(total_seconds/60);

            if ( seconds < 10 )
            {
                seconds = '0' + seconds;
            }

            if ( minutes < 10 )
            {
                minutes = '0' + minutes;
            }

            return minutes + ":" + seconds;
        },

        status_string() 
        {
            if ( this.progress.bulk_message_state == 'finished' ) 
                return "Complete";

            return "Sending";
        },

        percent_total() {
            let percent = (this.progress.count_total - this.progress.count_pending) / this.progress.count_total;
            return Math.floor(100*percent);
        },
    },
}
</script>

<style lang="scss" scoped>

</style>